const { getFullDate } = require('./getFullDate')
const { addSubDays } = require('./addSubDays')

/**
 * Egy adott dátumból kivon/hozzáad egy adott mennyiségű napot.
 * @param {string} date      - A dátum amiből ki akarunk vonni.
 * @param {'+' | '-'}operation - Milyen operációt szeretnénk végrehajtani a dátumon.
 * @param {number} dayCount  - Azon napok száma, ahány napot szeretnénk kivonni.
 * @returns {string} A módosított dátum.
 */
module.exports.addSubDaysFullDate = function addSubDaysFullDate (date, operation, dayCount) {
  return getFullDate(addSubDays(date, operation, dayCount))
}
